export const ytPlayerSrc = 'https://www.youtube.com/player_api'
export const twitchPlayerSrc = 'https://player.twitch.tv/js/embed/v1.js'
export const facebookPlayerSrc = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2'
export const tiktokPlayerSrc = 'https://www.tiktok.com/embed.js'
